
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface AvatarDisplayProps {
  avatar_url: string;
  full_name: string;
}

export function AvatarDisplay({ avatar_url, full_name }: AvatarDisplayProps) {
  const initials = full_name.split(' ').map(n => n[0]).join('');

  return (
    <Avatar className="h-16 w-16">
      {avatar_url && avatar_url !== "/placeholder.svg" ? (
        <AvatarImage src={avatar_url} alt={full_name} className="object-cover" />
      ) : null}
      <AvatarFallback className="bg-white/10 text-white text-lg">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
